<template>
  <ListComponent title="Sub Hire Job - Approved" :totalCount="totalItems">
    <template #list>
      <v-row class="ma-0">
        <v-col cols="7" class="px-0 pt-0 pb-2 d-flex align-center">
          <v-text-field
            label="Search On Enter"
            outlined
            dense
            append-icon="mdi-magnify"
            clearable
            hide-details="auto"
            @click:clear="onEnter()"
            v-on:keyup.enter="onEnter"
            v-model="filters.search"
          />
          <v-tooltip top>
            <template #activator="{ on, attrs }">
              <v-btn
                depressed
                icon
                v-on="on"
                v-bind="attrs"
                @click="showFilterDialog = true"
                class="mx-2"
              >
                <v-badge
                  dot
                  color="primary"
                  :value="Object.keys(filters).length"
                >
                  <v-icon>mdi-filter</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span v-if="Object.keys(filters).length == 0">Filters</span>

            <v-row v-else no-gutters>
              <v-col cols="12" class="font-weight-bold">Applied Filters</v-col>
              <v-col cols="12">
                <span
                  v-for="(value, key) in filters"
                  :key="key"
                  class="text-capitalize"
                  >{{ key.replace("_", " ") }}
                  <br />
                </span>
              </v-col>
            </v-row>
          </v-tooltip>
          <v-chip
            small
            class="flex-shrink-0 mr-2"
            :color="filters.auto_approved ? 'primary' : ''"
            :outlined="!filters.auto_approved"
            @click="toggleAutoApproved"
          >
            <v-icon left x-small>mdi-robot-outline</v-icon>
            Auto approved
          </v-chip>
          <Columns :headers="headers" :gridColInstance="gridColumnApi" />
          <v-spacer></v-spacer>

          <span class="text-h6 font-weight-regular text-no-wrap">
            Total Sub-Hire-
            <span class="font-weight-bold"> {{ SubHireCount }} </span>
          </span>
        </v-col>

        <v-col
          v-if="totalItems > 0"
          cols="5"
          class="px-0 pt-0 pb-2 d-flex justify-end"
        >
          <Pagination
            :pageNo="pageNo"
            :totalItems="totalItems"
            :pageSize="itemsPerPage"
            @itemsPerPageChange="itemsPerPageChanged"
            @prevPage="prevPage"
            @nextPage="nextPage"
          />
        </v-col>

        <v-col cols="12" class="pa-0">
          <AgGridVue
            style="width: 100%; height: calc(100vh - 172px)"
            class="ag-theme-alpine"
            id="myGrid"
            :columnDefs="headers"
            :context="context"
            @grid-ready="onGridReady"
            @columnMoved="resizeGrid"
            @columnVisible="resizeGrid"
            :defaultColDef="defaultColDef"
            :grid-options="gridOptions"
            rowSelection="multiple"
            @selection-changed="onSelectionChanged"
            :suppressDragLeaveHidesColumns="true"
            :rowData="subHireList"
          ></AgGridVue>
        </v-col>
      </v-row>
      <DetailsParent v-model="subHireJobLogDetailsDrawer" :resizable="true">
        <template #details>
          <v-card elevation="0">
            <v-card-title class="heading">
              <span class="text-h6">Sub Hire Job Logs</span>
            </v-card-title>

            <v-card-text>
              <v-row class="Order-Log-Scrolling-Class mt-3">
                <v-col cols="12">
                  <span
                    class="py-12"
                    v-if="subHireJobLogs && subHireJobLogs.length == 0"
                  >
                    No logs to show!
                  </span>

                  <v-timeline dense clipped v-else>
                    <v-timeline-item
                      v-for="(log, i) in subHireJobLogs"
                      :key="i"
                      icon-color="primary"
                      small
                    >
                      <v-card class="elevation-2">
                        <v-card-text>
                          <table class="Full-Width">
                            <tbody>
                              <tr>
                                <th class="text-left">{{ log.updated_by }}</th>
                                <td class="text-caption text-right">
                                  {{ log.created | formatDate(true) }}
                                </td>
                              </tr>
                              <tr>
                                <td colspan="2">{{ log.message }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </v-card-text>
                      </v-card>
                    </v-timeline-item>
                  </v-timeline>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </template>
      </DetailsParent>
    </template>

    <template #dialogs>
      <AdminSubHireFilters
        v-model="showFilterDialog"
        :bindingObject="filters"
        @resetFilters="resetFilters"
        @applyFilters="itemsPerPageChanged(20)"
      />

      <SubHireInvoiceDialog
        v-model="subHireInvoiceDialog"
        :subHireId="subHireId"
        :status="subHireStatus"
        @refreshList="getSubHireList()"
      />

      <SubHireInvoiceDialog
        v-model="bulkInvoiceDialog"
        :subHireId="null"
        :status="'Approved'"
        :isBulk="true"
        :bulkIds="selectedSubHireJob"
        @refreshList="getSubHireList(); selectedSubHireJob = [];"
      />
      <!-- <SubHireDetail
        v-model="showSubhireDetailDialog"
        :subHireObjId="subhirejobid"
      /> -->
      <SubhireForm
        v-model="showSubhireDialog"
        :subHireID="subhirejobid"
        :legId="defaultLegId"
        :status="subhire_status"
        @refreshList="getSubHireList()"
      />
      <SubHireDetailView
        v-model="showSubhireDetailDialog"
        :subHireID="subhirejobid"
      />
    </template>

    <template #actions>
       <v-btn
        v-if="selectedSubHireJob && selectedSubHireJob.length"
        depressed
        small
        color="primary"
        class="white--text mr-3"
        @click="bulkInvoiceDialog = true"
      >
        Update Invoice Details
      </v-btn>
      <v-btn
        v-if="selectedSubHireJob && selectedSubHireJob.length"
        depressed
        small
        color="primary"
        class="mr-2"
        @click="revertSubHireStatus()"
      >
        Revert Status Update
      </v-btn>
     
    </template>
  </ListComponent>
</template>

<script>
import ListComponent from "@/components/General/ListComponent.vue";
import Columns from "@/components/General/Columns.vue";
import { AgGridVue } from "ag-grid-vue";
import Pagination from "@/components/General/Pagination.vue";
import SubHireButton from "@/components/AgGridComponents/SubHireButton.vue";
import CustomHeader from "@/components/AgGridComponents/General/CustomHeader.vue";
import SubHireInvoiceDialog from "@/components/ModuleBased/dialogs/SubHireInvoiceDialog.vue";
import SubHireDetail from "@/components/ModuleBased/details/SubHireDetail.vue";
import SubhireForm from "@/components/ModuleBased/dialogForms/SubhireForm.vue";
import SubHireDetailView from "@/components/ModuleBased/details/SubHireDetailView.vue";
import DetailsParent from "@/components/General/DetailsParent.vue";
import AdminSubHireFilters from "@/components/ModuleBased/dialogs/filters/AdminSubHireFilters.vue";

import {
  isAuthenticated,
  hasRouteAccess,
  getPermissions,
} from "@/utils/functions";

export default {
  components: {
    ListComponent,
    Columns,
    AgGridVue,
    Pagination,
    SubHireButton,
    agColumnHeader: CustomHeader,
    SubHireInvoiceDialog,
    SubHireDetail,
    SubhireForm,
    SubHireDetailView,
    AdminSubHireFilters,
    DetailsParent,
  },

  data() {
    return {
      sorting: {},
      subHireId: null,
      subHireStatus: null,
      bulkInvoiceDialog: false,
      subhire_status: "Approved",

      headers: [
        {
          headerName: "Sub Hire ID",
          field: "sub_hire_id",
          sortable: true,
          minWidth: 140,
          headerCheckboxSelection: true,
          checkboxSelection: true,
        },
        {
          headerName: "Creation Date",
          field: "created",
          tooltipField: "created",
          sortable: true,
          minWidth: 120,
          valueFormatter: (params) => {
            return this.$globals.formatDate(params.value);
          },
        },
        {
          headerName: "Transporter",
          field: "transporter_company_name",
          tooltipField: "transporter_company_name",
          sortable: true,
          minWidth: 120,
        },
        {
          headerName: "Route",
          field: "leg_lane_title",
          tooltipField: "leg_lane_title",
          sortable: true,
          minWidth: 100,
        },
        {
          headerName: "DA(s)",
          field: "sub_hire_leg_count",
          sortable: true,
          minWidth: 60,
        },
        {
          headerName: "Customer",
          field: "customer",
          sortable: true,
          minWidth: 120,
        },
        {
          headerName: `Revenue (${this.$globals.currency})`,
          field:
            "total_revenue",
          sortable: true,
          minWidth: 120,
        },
        {
          headerName: `Tax Amount(${this.$globals.currency})`,
          field: "total_revenue_tax_amount",
          sortable: true,
          minWidth: 120,
        },
        {
          headerName: `Cost (${this.$globals.currency})`,
          field: "total_cost",
          tooltipField: "total_cost",
          sortable: true,
          minWidth: 110,
        },
        {
          headerName: `Tax Amount(${this.$globals.currency})`,
          field: "total_taxable_amount",
          sortable: true,
          minWidth: 120,
        },
        {
          headerName: `Margin Amount (${this.$globals.currency})`,
          field: "margin_amount",
          sortable: true,
          minWidth: 150,
        },
        {
          headerName: "Margin %",
          field: "margin_percentage",
          sortable: true,
          minWidth: 150,
        },
        {
          headerName: "Approved By",
          field: "approved_by",
          sortable: true,
          minWidth: 100,
        },
        {
          headerName: "Actions",
          field: "actions",
          cellRendererFramework: "SubHireButton",
          pinned: "right",
          minWidth: 260,
        },
      ],

      subHireList: [],
      subhirejobid: null,
      showSubhireDetailDialog: false,
      SubHireCount: 0,

      selectedrowData: [],
      selectedSubHireJob: [],

      // Details vars
      selectedSubHireId: null,
      permissions: null,

      subHireJobLogDetailsDrawer: false,
      subHireJobLogs: [],

      // pagination vars
      pageNo: 1,
      itemsPerPage: 20,
      totalItems: 0,

      // Filter vars
      filters: {},
      showFilterDialog: false,
      subHireInvoiceDialog: false,
      showSubhireDialog: false,
      defaultLegId: null,

      // ag-grid vars
      gridApi: null,
      gridColumnApi: null,
      defaultColDef: {
        resizable: true,
      },
      gridOptions: {
        onGridSizeChanged: () => {
          this.resizeGrid();
        },
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true,
        enableCellTextSelection: true,
        tooltipShowDelay: 0,
        rowHeight: 35,
      },
    };
  },

  computed: {
    context() {
      return { parentComponent: this };
    },
    currentProfile() {
      let obj = JSON.parse(localStorage.getItem("userProfile"));
      if (!obj) {
        return null;
      } else {
        return obj;
      }
    },
    offset() {
      return this.itemsPerPage * (this.pageNo - 1);
    },
  },

  methods: {
    viewSubHireLogs(id) {
      this.subHireJobLogDetailsDrawer = true;
      this.$bus.$emit("showLoader", true);
      this.$api.subHire
        .getSubHireJObLogs(id)
        .then((res) => {
          this.subHireJobLogs = res.data;
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
          this.$bus.$emit("showToastMessage", {
            message: "Couldn't fetch sub hire job logs!",
            color: "error",
          });
          this.formErrors = err.data;
        });
    },
    revertSubHireStatus() {
      const config = {
        status: "secondary",
        title: "Sub Hire Job Status Update",
        text: "Are you sure you want to update the status to Pending?",
      };
      this.$confirm(config).then(() => {
        this.$bus.$emit("showLoader", true);
        let sub_hire_ids = [...this.selectedSubHireJob];
        this.$api.subHire
          .approvedToPending(sub_hire_ids)
          .then((resp) => {
            this.$bus.$emit("showLoader", false);
            this.$bus.$emit("showToastMessage", {
              message: "Sub Hire Status Changed To Pending!",
              color: "success",
            });
            this.getSubHireList();
            this.resetForm();
            this.SubHireCount = 0;
          })
          .catch((err) => {
            console.error(err);
            this.$bus.$emit("showLoader", false);
          });
      });
    },
    onSelectionChanged() {
      this.selectedrowData = this.gridApi.getSelectedRows();
      this.SubHireCount = this.selectedrowData.length;

      this.selectedSubHireJob = [];
      for (let i = 0; i < this.selectedrowData.length; i++) {
        this.selectedSubHireJob.push(this.selectedrowData[i].id);
      }
    },
    editSubHire(id, legId) {
      this.subhirejobid = id;
      this.defaultLegId = legId;

      this.showSubhireDialog = true;
    },
    openSubHireDetailsPage(id) {
      this.$router.push({ path: `/app/admin/sub-hire/details/${id}` });
    },
    viewSubHire(id) {
      this.subhirejobid = id;
      this.showSubhireDetailDialog = true;
    },
    invoiceUpdatedSubHire(id, status) {
      this.subHireStatus = status;
      this.subHireId = id;
      this.subHireInvoiceDialog = true;
    },
    resizeGrid() {
      if (this.gridOptions && this.gridOptions.api) {
        setTimeout(() => {
          this.gridOptions.api.sizeColumnsToFit();
        }, 100);
      }
    },
    resetFilters() {
      this.filters = {};
      this.itemsPerPageChanged(20);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.resizeGrid();
    },
    onEnter() {
      this.SubHireCount = 0;
      this.pageNo = 1;
      setTimeout(() => {
        this.getSubHireList();
      }, 10);
    },
    toggleAutoApproved() {
      if (this.filters.auto_approved) {
        this.$delete(this.filters, "auto_approved");
      } else {
        this.$set(this.filters, "auto_approved", true);
      }
      this.onEnter();
    },
    itemsPerPageChanged(e) {
      this.SubHireCount = 0;
      this.pageNo = 1;
      this.itemsPerPage = e;
      this.getSubHireList();
    },
    prevPage() {
      this.SubHireCount = 0;
      this.pageNo--;
      this.getSubHireList();
    },
    nextPage() {
      this.SubHireCount = 0;
      this.pageNo++;
      this.getSubHireList();
    },
    applyGridSort(key, type) {
      if (this.filters && !this.filters.ordering) {
        this.filters.ordering = [];
      }

      if (type == null) {
        delete this.sorting[key];
        this.filters.ordering.splice(
          this.filters.ordering.indexOf(`-${key}`),
          1
        );
      } else if (type == "asc") {
        this.filters.ordering.push(key);
      } else if (type == "desc") {
        this.filters.ordering.splice(
          this.filters.ordering.indexOf(key),
          1,
          `-${key}`
        );
      }
      if (this.filters.ordering.length == 0) {
        delete this.filters.ordering;
      }
      this.itemsPerPageChanged(20);
    },
    apporvedSubHire(id, status) {
      if (confirm(`Are you sure you want to approved the subhire`)) {
        this.$bus.$emit("showLoader", true);
        this.$api.subHire
          .approvedSubhire(id, status)
          .then((res) => {
            this.$emit("refreshList");
            this.$bus.$emit("showToastMessage", {
              message: "Invoice Detail Updated Successfully!",
              color: "success",
            });
            this.$bus.$emit("showLoader", false);
            this.SubHireCount = 0;
          })
          .catch((err) => {
            this.$bus.$emit("showToastMessage", {
              message: `${
                err.data && err.data.non_field_errors
                  ? err.data.non_field_errors.join()
                  : "Sub Hire can't be approved"
              }`,
              color: "error",
            });
            this.$bus.$emit("showLoader", false);
          });
      }
    },

    getSubHireList(params = {}) {
      this.$bus.$emit("showLoader", true);
      params = {
        status: "Approved",
        offset: this.offset,
        limit: this.itemsPerPage,
        company: this.currentProfile.company,
        ...params,
        ...this.filters,
      };
      if ("ordering" in params && params.ordering.length > 0) {
        params = { ...params, ordering: params.ordering.join(",") };
      }
      this.$api.subHire
        .getSubHireList(params)
        .then((res) => {
          this.subHireList = res.data;
          this.totalItems = res.count;
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
  },

  beforeMount() {
    if (!isAuthenticated()) {
      this.$router.push("/");
    } else if (!hasRouteAccess(this.$route)) {
      this.$router.push(`/${localStorage.getItem("user_type").toLowerCase()}`);
    } else {
      const permissions = getPermissions("subhire_approved");
      if (!permissions || !permissions.view) {
        this.$bus.$emit("showToastMessage", {
          message: "You don't have access to this page",
          color: "error",
        });
        this.$router.push(
          `/app/${
            localStorage.getItem("user_type")
              ? localStorage.getItem("user_type").toLowerCase()
              : "error"
          }`
        );
      } else {
        this.permissions = { ...permissions };
        this.getSubHireList();
      }
    }
  },
};
</script>
